import React from 'react';

import Seo from '../components/Seo/Seo';
import ServiceReferenceSection from '../data/Home/ServiceReferenceSection';
import BlogSection from '../components/HomeBlogSection/HomeBlogSection';
import AboutUsSection from '../data/Home/AboutUsSection';
import ContactReference from '../components/ProjectRequestSection/ProjectRequestSection';
import HeroSection from '../data/Home/HomeHeroSection';
import NewHomeLogoSlider from '../data/Home/HomeLogoSlider';
import OurBenefitsSection from '../data/Home/OurBenefitSection';
import CodeTerminalSection from '../data/Home/CodeTerminalSection';

import RPASection from "../components/RPASection/RPASection";
import WebRpaData from "../data/Home/HomeRpaData";


const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Nexite IT',
  url: 'https://www.nexite-it.com/',
  inLanguage: 'de',
  publisher: { '@id': 'https://www.nexite-it.com/#organization' },
};

const Home = () => {
  return (
    <>
      <Seo
        title="Nexite IT – Webentwicklung, Apps & UI/UX Design aus Köln"
        description="Nexite IT ist Ihre Kölner Agentur für moderne Webentwicklung, App-Entwicklung und UI/UX Design. Wir entwickeln digitale Lösungen für Industrie und Mittelstand – jetzt Projekt anfragen."
        path="/"
        jsonLd={websiteJsonLd}
      />

      <HeroSection />
      <NewHomeLogoSlider />
      <ServiceReferenceSection />  
      <AboutUsSection />
      <OurBenefitsSection />
      <RPASection data={WebRpaData} />
      <CodeTerminalSection />
      <BlogSection />
      <ContactReference />
    </>
  );
};

export default Home;
